<section class="modal-section {{ data?.modalClass }}">
    <xm-modal-close *ngIf="data.close" xmEscKey (escKeyPressed)="close('close')" (onClose)="close('close')"></xm-modal-close>
    <h2 mat-dialog-title>{{ data.header }}</h2>
    <div class="subheader">{{ data.subheader }}</div>
    <div class="content-header" *ngIf="data.contentHeader"><span class="content-header-text">{{ data.contentHeader }}</span></div>
    <div class="content">
        <div *ngFor="let info of data.content" class="tile">
            <xm-media-image [imageOptions]="info.imageOptions" size="height"></xm-media-image>
            <div class="tile-content">
                <h3>{{ info.header }}</h3>
                <cms-text [underlineLink]="true" class="body" *ngFor="let item of info.body" [originalText]="item"></cms-text>
            </div>
        </div>
    </div>
    <div class="ruler" *ngIf="data.showRuler"></div>
    <div class="buttons">
        <cms-text *ngIf="data.primaryButton" class="primary" [originalText]="data.primaryButton" (onButtonClick)="close('primary')"></cms-text>
        <xm-decorated-text *ngIf="data.crossAppNavigationButton" class="primary" [inputString]="data.crossAppNavigationButton"></xm-decorated-text>
        <cms-text *ngIf="data.secondaryButton" class="secondary" [originalText]="data.secondaryButton" (onButtonClick)="close('secondary')"></cms-text>
    </div>
    <cms-text class="footnote" [originalText]="data.footnote"></cms-text>
</section>
